import React from 'react';
import { Box, Typography } from '@material-ui/core';
import DefaultModal from '../DefaultModal';
import useStyles from './styles';

export const ENDING_LOCATIONS = {
  activity: 'vos activités',
  agenda: 'votre agenda',
  employee: 'votre équipe',
  description: 'la description de votre entreprise',
};

const BlockWithoutStepModal = ({ endingLocation = 'cette page', ...rest }) => {
  const classes = useStyles();

  return (
    <DefaultModal forceConfirm info title="Attention" square {...rest}>
      <Box className={classes.modalContent}>
        <Typography className={classes.modalText} align="center">
          Vous devez terminer les tâches de configuration du tableau de bord avant d'accéder à
          <span className={classes.importantText}> {endingLocation}</span>.
        </Typography>
      </Box>
    </DefaultModal>
  );
};

export default BlockWithoutStepModal;
